import { render, staticRenderFns } from "./SlotsList.vue?vue&type=template&id=801d6382&scoped=true&lang=pug"
import script from "./SlotsList.vue?vue&type=script&lang=js"
export * from "./SlotsList.vue?vue&type=script&lang=js"
import style0 from "./SlotsList.vue?vue&type=style&index=0&id=801d6382&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "801d6382",
  null
  
)

export default component.exports